import { render, staticRenderFns } from "./paid-sick-leave-home.vue?vue&type=template&id=b88cd224"
import script from "./paid-sick-leave-home.vue?vue&type=script&lang=js"
export * from "./paid-sick-leave-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports